import { Tooltip, TooltipContent, TooltipTrigger } from "design-system/atoms/Tooltip"
import { cn } from "design-system/utils"
import { LanguageEnum } from "lopermut"
import { useLanguageLabel } from "modules/shared/hooks/useLanguageLabel"
import * as React from "react"

type LocaleProps = {
  code: string
}

const Locale: React.FC<LocaleProps> = ({ code }) => {
  const languageLabel = useLanguageLabel()

  if (!LanguageEnum[code]) {
    return <span className="text-muted-foreground font-mono">{code}</span>
  }

  return (
    <Tooltip>
      <TooltipTrigger className={cn("cursor-pointer")}>
        <span>{languageLabel(code)}</span>
      </TooltipTrigger>
      <TooltipContent>
        <span className="font-mono">{code}</span>
      </TooltipContent>
    </Tooltip>
  )
}

export default Locale
